(() => {
  const selector = [
    '.skovn-category',
    '.skovn-product',
    '.skovn-look',
    '.skovn-promise',
    '.skovn-card',
    '.skovn-list-collections__card',
    '.skovn-story__row',
    '.skovn-faq__item',
    '.skovn-product-main__media-item',
    '.skovn-product-main__details',
    '.skovn-contact__details',
    '.skovn-contact__form'
  ].join(',');

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let observer;

  document.addEventListener('click', (event) => {
    const control = event.target.closest('[data-skovn-card-direction]');
    if (!control) return;
    const card = control.closest('[data-skovn-card]');
    const images = Array.from(card?.querySelectorAll('.skovn-card__image') || []);
    if (images.length < 2) return;

    const currentIndex = Number(card.dataset.skovnCardImageIndex || 0);
    const direction = control.dataset.skovnCardDirection === 'previous' ? -1 : 1;
    const nextIndex = (currentIndex + direction + images.length) % images.length;

    images.forEach((image, index) => {
      image.classList.toggle('is-active', index === nextIndex);
      image.setAttribute('aria-hidden', index === nextIndex ? 'false' : 'true');
    });
    card.dataset.skovnCardImageIndex = String(nextIndex);
  });

  const prepareCardImages = (root = document) => {
    root.querySelectorAll('[data-skovn-card]').forEach((card) => {
      const images = Array.from(card.querySelectorAll('.skovn-card__image'));
      if (!images.length || card.dataset.skovnCardImagesReady === 'true') return;
      card.dataset.skovnCardImagesReady = 'true';
      card.dataset.skovnCardImageIndex = '0';
      images.forEach((image, index) => {
        image.classList.toggle('is-active', index === 0);
        image.setAttribute('aria-hidden', index === 0 ? 'false' : 'true');
      });
    });
  };

  const revealAll = (root = document) => {
    root.querySelectorAll(selector).forEach((element) => {
      element.dataset.skovnMotion = '';
      element.classList.add('is-visible');
    });
  };

  const prepare = (root = document) => {
    const elements = Array.from(root.querySelectorAll(selector)).filter(
      (element) => !element.hasAttribute('data-skovn-motion')
    );

    elements.forEach((element) => {
      const siblings = Array.from(element.parentElement?.children || []).filter((child) => child.matches?.(selector));
      const index = Math.max(0, siblings.indexOf(element));
      element.dataset.skovnMotion = '';
      element.style.setProperty('--skovn-motion-delay', `${Math.min(index * 70, 350)}ms`);

      if (reducedMotion.matches) {
        element.classList.add('is-visible');
      } else {
        observer.observe(element);
      }
    });
  };

  prepareCardImages();

  if (!('IntersectionObserver' in window) || reducedMotion.matches) {
    document.documentElement.classList.add('skovn-motion-ready');
    revealAll();
    return;
  }

  observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    },
    {
      threshold: 0.08,
      rootMargin: '0px 0px -7% 0px'
    }
  );

  document.documentElement.classList.add('skovn-motion-ready');
  prepare();
  document.addEventListener('shopify:section:load', (event) => {
    prepareCardImages(event.target);
    prepare(event.target);
  });
  reducedMotion.addEventListener?.('change', (event) => {
    if (event.matches) revealAll();
  });

})();
